import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useUpdateCustomer, CustomerFormInput } from "../../api/customers";
import { useToast } from "../../components/ToastProvider";
import { CustomerDetail } from "../../types/dtos";
import { CustomerFormFields, BLANK_CUSTOMER_FORM } from "./CustomerFormFields";

export function EditCustomerModal({ customer, onClose }: { customer: CustomerDetail | null; onClose: () => void }) {
  const [form, setForm] = useState<CustomerFormInput>(BLANK_CUSTOMER_FORM);
  const [error, setError] = useState<string | null>(null);

  const update = useUpdateCustomer();
  const toast = useToast();

  useEffect(() => {
    if (customer) {
      setForm({
        razaoSocial: customer.razaoSocial,
        nomeFantasia: customer.nomeFantasia ?? "",
        cnpjCpf: customer.cnpjCpf,
        personType: customer.personType,
        email: customer.email,
        phone: customer.phone ?? "",
        cep: customer.cep ?? "",
        logradouro: customer.logradouro ?? "",
        numero: customer.numero ?? "",
        complemento: customer.complemento ?? "",
        bairro: customer.bairro ?? "",
        cidade: customer.cidade ?? "",
        uf: customer.uf ?? "",
      });
      setError(null);
    }
  }, [customer]);

  if (!customer) return null;

  function patch(p: Partial<CustomerFormInput>) {
    setForm((prev) => ({ ...prev, ...p }));
  }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!form.razaoSocial.trim()) return setError("Preencha a razão social do cliente.");
    if (!form.cnpjCpf.trim()) return setError("Informe o CNPJ/CPF do cliente.");
    if (!form.email.trim()) return setError("Informe o e-mail de cobrança.");
    if (!customer) return;

    try {
      await update.mutateAsync({ id: customer.id, input: form });
      toast("Cliente atualizado.");
      onClose();
    } catch {
      setError("Não foi possível salvar as alterações — confira se o CNPJ/CPF já não está em uso.");
    }
  }

  return (
    <Modal backdrop="static" keyboard={false} show onHide={onClose} centered className="nt-dialog" size="lg">
      <form onSubmit={handleSubmit}>
        <Modal.Header closeButton closeVariant="white">
          <Modal.Title style={{ fontSize: 20, fontFamily: "var(--font-heading)" }}>Editar cliente</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CustomerFormFields value={form} onChange={patch} />
          {error && (
            <div className="text-danger mt-2" style={{ fontSize: 12.5 }}>
              {error}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-danger" onClick={onClose}>
            Cancelar
          </button>
          <button type="submit" className="btn btn-success" disabled={update.isPending}>
            Salvar alterações
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
